import React, { useMemo } from "react";
import {
  Card,
  Typography,
  Radio,
  Button,
  Space,
  Divider,
  message,
  Form,
  Empty,
  Tag,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const { Text } = Typography;

const voteOptions = [
  { value: 1, label: "Tán thành" },
  { value: 0, label: "Không tán thành" },
];

const VotingList = ({
  questions = [],
  userId,
  fetchData,
  form,
  submitted = false,
  url,
}) => {
  const openQuestions = useMemo(() => questions, [questions]);

  const handleSubmit = async (values) => {
    // if (submitted) {
    //   message.warning("Bạn đã gửi phiếu biểu quyết");
    //   return;
    // }

    try {
      const payload = {
        userId,
        votes: values.votes.filter((x) => x.state === 1),
      };

      const res = await fetch(`${url}/bieu-quyet-confirm-by-user`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error("API error");
      }

      fetchData();
      message.success("Phiếu biểu quyết đã được ghi nhận");
    } catch (error) {
      message.error("Có lỗi xảy ra khi gửi phiếu");
    }
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size={24}>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Biểu quyết</span>
            <Button icon={<ReloadOutlined />} onClick={fetchData}>
              Tải lại
            </Button>
          </div>
        }
        style={{ borderRadius: 12 }}
      >
        {questions.length > 0 ? (
          <>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Form.List name="votes">
                {(fields) => (
                  <>
                    {fields.map((field, index) => {
                      const question = openQuestions[index];
                      return (
                        <div key={field.key}>
                          <Text strong>
                            {index + 1}.{" "}
                            <Tag
                              color={
                                question.state === 1
                                  ? "green"
                                  : question.state === 2
                                  ? "red"
                                  : "blue"
                              }
                            >
                              {question.state === 1
                                ? "Đã mở"
                                : question.state === 2
                                ? "Đã đóng"
                                : "Chưa mở"}
                            </Tag>
                            {question?.cauHoi}
                          </Text>

                          <Form.Item name={[field.name, "questionId"]} hidden />

                          <Form.Item
                            name={[field.name, "status"]}
                            rules={[
                              {
                                required: question.state === 1,
                                message: "Vui lòng chọn phương án",
                              },
                            ]}
                            style={{ marginTop: 8 }}
                          >
                            <Radio.Group disabled={!(question.state === 1)}>
                              <Space>
                                {voteOptions.map((option) => (
                                  <Radio
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </Radio>
                                ))}
                              </Space>
                            </Radio.Group>
                          </Form.Item>
                          <Divider />
                        </div>
                      );
                    })}
                  </>
                )}
              </Form.List>
            </Form>
            <Button
              type="primary"
              size="large"
              block
              onClick={() => form.submit()}
              style={{ height: 50, fontWeight: 600 }}
              disabled={!submitted}
            >
              Xác nhận gửi phiếu biểu quyết
            </Button>
          </>
        ) : (
          <Empty description="Chưa có danh sách biểu quyết." />
        )}
      </Card>
    </Space>
  );
};

export default VotingList;
